import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/lib/lang";

/* Dedicated presentation page for a Celtic voice: portrait + story + facts + embedded chat. */
export default function CelticPersonaPage({ id, Icon, accent, content, children }) {
  const { lang } = useLang();
  const c = content[lang] || content.fr;
  return (
    <>
      <Navbar />
      <main data-testid={`${id}-dedicated-page`} className="relative pt-36 pb-20 overflow-x-hidden">
        <section className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-4 flex justify-center fade-up">
            <div className="relative">
              <div className="absolute -inset-6 rounded-full slowspin opacity-60"
                   style={{ background: `conic-gradient(from 0deg, transparent, ${accent}66, transparent 60%)`, filter: "blur(24px)" }} />
              <div data-testid={`${id}-portrait`} aria-hidden="true"
                   className="relative w-56 h-56 sm:w-64 sm:h-64 rounded-full flex items-center justify-center"
                   style={{ background: `radial-gradient(circle at 30% 30%, ${accent}44, rgba(10,6,20,0.95) 70%)`, boxShadow: `0 0 0 3px ${accent}88, 0 30px 80px -20px ${accent}66` }}>
                <Icon size={96} strokeWidth={1.2} style={{ color: accent }} />
              </div>
            </div>
          </div>
          <div className="lg:col-span-8 fade-up">
            <div className="overline mb-4" style={{ color: accent }}><span className="kicker-line" />{c.kicker}</div>
            <h1 data-testid={`${id}-page-title`} className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.04]">{c.title}</h1>
            <p className="mt-6 text-base sm:text-lg leading-relaxed max-w-3xl" style={{ color: "var(--violet-soft)" }}>{c.intro}</p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-5 sm:px-8 mt-16 grid grid-cols-1 md:grid-cols-3 gap-4">
          {c.facts.map(([t, d], i) => (
            <div key={t} data-testid={`${id}-fact-${i}`} className="mystic-card rounded-3xl p-6" style={{ borderColor: `${accent}33` }}>
              <div className="font-display text-sm uppercase tracking-widest" style={{ color: accent }}>{t}</div>
              <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--violet-soft)" }}>{d}</p>
            </div>
          ))}
        </section>

        <section className="max-w-4xl mx-auto px-5 sm:px-8 mt-16">
          <h2 className="font-serif text-2xl sm:text-3xl mb-6">{c.chatTitle}</h2>
          {children}
        </section>
      </main>
      <Footer />
    </>
  );
}
